import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';
import { MfaVerifyModal } from '@/features/auth/components/mfa/MfaVerifyModal';

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
      <MfaVerifyModal />
    </Providers>
  );
}
